import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import type { PackageSet } from '@shipstation/client-common/types/seller-data';

import { Button } from 'ui-components/components/button';

import { DeletePackageSetModalWrapper } from './delete-package-set-modal';

import style from './multi-package-modal.module.less';
import { messages } from './messages';

type PackageSetsListProps = {
  applyPackageSetFromList: (packageSet: PackageSet) => void;
  packageSetsList?: PackageSet[];
  packageSetsListClassName?: string;
};

export const PackageSetsList = ({ applyPackageSetFromList, packageSetsList = [], packageSetsListClassName }: PackageSetsListProps) => {
  return (
    <DeletePackageSetModalWrapper>
      {({ openModal }) => {
        return (
          <DropdownMenu className={packageSetsListClassName}>
            <DropdownMenuToggler buttonSize='small' theme='link'>
              <FormattedMessage {...messages.multiPackageApplySetButton} />
            </DropdownMenuToggler>
            {packageSetsList.map((packageSetInList, index) => {
              return (
                <DropdownMenuItem key={index} className={style['package-set-dropdown']}>
                  <div className={style['package-set-button']}>
                    <div className={style['package-set-name']} onClick={() => applyPackageSetFromList(packageSetInList)}>
                      {packageSetInList.name}
                    </div>
                    <Button
                      className={style['x-button']}
                      onClick={() => openModal(packageSetInList.packageSetId, packageSetInList.name)}
                      theme='unstyled'
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </Button>
                  </div>
                </DropdownMenuItem>
              );
            })}
          </DropdownMenu>
        );
      }}
    </DeletePackageSetModalWrapper>
  );
};
